import type { Capability } from '@taler/api-client'

/** The one place this feature's view gate is written; the page and the nav both call it. */
export function canViewTransactions(can: (capability: Capability) => boolean): boolean {
  return can('ENTRY_VIEW_ALL') || can('ENTRY_VIEW_OWN')
}

/**
 * Unlike view, the `Capability` enum has no `ENTRY_EDIT_OWN` counterpart to `ENTRY_EDIT_ANY` -
 * only the `_ANY` form exists, so editing any entry, including one's own, gates on it. Presentation
 * only: the server re-checks every call.
 */
export function canEditEntry(can: (capability: Capability) => boolean): boolean {
  return can('ENTRY_EDIT_ANY')
}

export function canReverseEntry(can: (capability: Capability) => boolean): boolean {
  return can('ENTRY_REVERSE_ANY')
}

/**
 * The `Capability` enum has no dedicated delete capability for an entry - `entries_delete`
 * gates on the same capability as replacing it, the same way `contacts_delete` gates on a
 * general capability rather than one invented for the operation.
 */
export function canDeleteEntry(can: (capability: Capability) => boolean): boolean {
  return can('ENTRY_EDIT_ANY')
}
